import { Box, Flex, Text, Textarea } from '@chakra-ui/react';
import { useField } from 'formik';

import { MAX_TEXT_LENGTH, MIN_TEXT_LENGTH, SchemaQuestion } from '../encodeDecodeAnswers';

type TextQuestionCardProps = {
  question: SchemaQuestion;
  label: string;
};

const TextQuestionCard = ({ question, label }: TextQuestionCardProps) => {
  const [field, meta] = useField<string>(question.questionId);
  const value = field.value ?? '';
  const error = meta.touched ? meta.error : undefined;

  return (
    <Box
      bg="amberLight"
      border="1px solid"
      borderColor="bananaMania"
      borderRadius="12px"
      px={4}
      py={3}
    >
      <Text
        fontSize="xs"
        fontWeight="700"
        color="darkGoldenrod"
        textTransform="uppercase"
        letterSpacing="0.04em"
        mb={2}
      >
        {label}
      </Text>
      <Textarea
        {...field}
        value={value}
        rows={3}
        maxLength={MAX_TEXT_LENGTH}
        placeholder="For example: it hesitates when it shifts into third."
        bg="white"
        borderRadius="12px"
        borderColor="gainsboro"
        fontSize="sm"
        _focusVisible={{ borderColor: 'leaseEndBlue', boxShadow: 'none' }}
      />
      <Flex justify="space-between" mt={1} fontSize="xs">
        <Text color={error ? 'leaseEndRed' : 'darkGoldenrod'} fontWeight="600">
          {error ?? `Required · at least ${MIN_TEXT_LENGTH} characters`}
        </Text>
        <Text color="grayLight">
          {value.length} / {MAX_TEXT_LENGTH}
        </Text>
      </Flex>
      <Text fontSize="sm" color="grayDark" mt={2}>
        On the next step, mark each area that has an issue.
      </Text>
    </Box>
  );
};

export default TextQuestionCard;
